import { render } from "./Press.vue?vue&type=template&id=81aad5d6&scoped=true&ts=true"
import script from "./Press.vue?vue&type=script&lang=ts"
export * from "./Press.vue?vue&type=script&lang=ts"

import "./Press.vue?vue&type=style&index=0&id=81aad5d6&scoped=true&lang=css"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81aad5d6"]])

export default __exports__